import React, { useState, useEffect } from "react";
import "./tabs.css";
import Energy from "../Energy/energy";
import Progress from "../Progress/progress";
import Emission from "../Emission/emission";
import Water from "../Water/Water";
import Waste from "../Waste/waste";
import Diversity from "../Diversity/Diversity";
import Safety from "../Safety/Safety";
import Training from "../Training/Training";
import Environment from "../Environment/environment";
import TrainingOverview from "../TrainingOverview/trainingOverview";
import TraineeOverview from "../TraineeOverviev/TraineeOverview";
import Employment from "../Employment/employment";
import IntensityDashboard from "../IntensityDashboard/IntensityDashboard";
import TrainingDashboard from "../Training/training-dashboard/TrainingDashboard";
import ESGProgressDashboard from "../Progress/ESGProgressDashboard";
import ESGEnvironmentDashboard from "../Environment/environment";
import Occupancy from "../Occupancy/occupancy";

const TabsComponent = ({
  setCurrentTab,
  fromDate,
  keyTab,
  toDate,
  locationOption,
  timePeriods,
  financialYearId,
  graphData,
  frameworkValue,
  sectorQuestionAnswerDataForGraph,
  framework,
  todaysActivities,
  compareLastTimePeriods,
  compareTCurrentimePeriods,
  financialYear,
  energyData,
  energyTriggerData,
  emissionTriggerData,
  permissionGraph,
  usersActivity,
  lastYearGraphData
}) => {
  const [activebtnTab, setactivebtnTab] = useState(0);
  const [permissionList, setPermissionList] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const [companyFramework, setCompanyFramework] = useState([]);
  const [companyId, setCompanyId] = useState();


  useEffect(() => {
    const dashboardMenu = JSON.parse(localStorage.getItem("menu"));
    const dashboardObject = dashboardMenu.find(
      (item) => item.caption === "Dashboard"
    ).permissions;
    setPermissionList(dashboardObject);

    // Set initial active tab based on user type and permissions
    if (currentUser.userType === "TRAINEE") {
      setactivebtnTab(10);
    } else {
      // Find first available tab based on permissions
      const firstAvailableTab = getFirstAvailableTab();
      setactivebtnTab(firstAvailableTab);
    }
  }, [permissionGraph]);

  useEffect(() => {
    if (Array.isArray(frameworkValue) && frameworkValue.length) {
      const frameworkId = frameworkValue.map((value) => value.id);
      setCompanyFramework(frameworkId);
    }
  }, [frameworkValue]);

  // Helper function to get the first available tab based on permissions
  const getFirstAvailableTab = () => {
    // Always show Progress tab if not TRAINEE
    if (currentUser.userType !== "TRAINEE") {
      return 0;
    }

    // For TRAINEE, show Trainee Overview
    return 11;
  };

  useEffect(() => {
    // Cleanup function to set isMounted to false when the component unmounts
    const currentUser = localStorage.getItem("tmpcurrentUser");
    if (currentUser) {
      setCompanyId(String(JSON.parse(currentUser).data.user.dataValues.company_id));
    }

  }, []);

  // Helper function to check if a tab should be visible based on permissionGraph
  const isTabVisible = (tabName) => {
    if (!permissionGraph) return true; // If permissions not loaded yet, show all tabs

    // Check if the tab has any permissions
    if (permissionGraph[tabName] && permissionGraph[tabName].length > 0) {
      return true;
    }

    // Special cases for tabs not directly in permissionGraph
    if (
      tabName === "Progress" ||
      tabName === "Trainer Overview" ||
      tabName === "Trainee Overview" ||
      tabName === "Intensity"
    ) {
      return true;
    }

    // Check if the tab is in companyFramework
    if (
      tabName === "Training" &&
      companyFramework &&
      companyFramework.includes(1)
    ) {
      return true;
    }

    return false;
  };

  const handleTabClick = (index) => {
    setactivebtnTab(index);
  };

  useEffect(() => {
    setCurrentTab(activebtnTab);
  }, [activebtnTab]);

  const renderUI = () => {
    switch (activebtnTab) {
      case 0:
        return (
          <ESGProgressDashboard
            framework={framework}
            timePeriods={timePeriods}
            fromDate={fromDate}
            toDate={toDate}
            financialYearId={financialYearId}
            locationOption={locationOption}
            todaysActivities={todaysActivities}
            usersActivity={usersActivity}
          />
        );
      case 1:
        return (
          <ESGEnvironmentDashboard
            keyTab={keyTab}
            graphData={graphData}
          />
        );
      case 2:
        return (
          <Energy
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            energyData={energyData}
            energyTriggerData={energyTriggerData}
          />
        );
      case 3:
        return (
          <Emission
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            energyData={energyData}
            emissionTriggerData={emissionTriggerData}
          />
        );
      case 4:
        return (
          <Water
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );
      case 5:
        return (
          <Waste
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );
      case 12:
        return (
          <IntensityDashboard
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
          />
        );
      case 6:
        return (
          <Diversity
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );
      case 7:
        return (
          <Employment
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );

      case 15:
        return (
          <Occupancy
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );
      case 8:
        return (
          <Safety
            keyTab={keyTab}
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
            compareLastTimePeriods={compareLastTimePeriods}
            compareTCurrentimePeriods={compareTCurrentimePeriods}
            financialYear={financialYear}
            lastYearGraphData={lastYearGraphData}
          />
        );
      case 9:
        return (
          companyFramework && companyFramework.includes(48) ?
            <Training
              keyTab={keyTab}
              locationOption={locationOption}
              timePeriods={timePeriods}
              financialYearId={financialYearId}
              graphData={graphData}
              frameworkValue={frameworkValue}
              compareLastTimePeriods={compareLastTimePeriods}
              compareTCurrentimePeriods={compareTCurrentimePeriods}
              financialYear={financialYear}
            /> : <TrainingDashboard
              keyTab={keyTab}
              locationOption={locationOption}
              timePeriods={timePeriods}
              financialYearId={financialYearId}
              graphData={graphData}
              frameworkValue={frameworkValue}
              compareLastTimePeriods={compareLastTimePeriods}
              compareTCurrentimePeriods={compareTCurrentimePeriods}
              financialYear={financialYear}
            />
        );
      case 10:
        return (
          <TrainingOverview
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
            graphData={graphData}
            frameworkValue={frameworkValue}
          />
        );
      case 11:
        return (
          <TraineeOverview
            locationOption={locationOption}
            timePeriods={timePeriods}
            financialYearId={financialYearId}
          />
        );
      default:
        return null;
    }
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  };

  const headerStyle = {
    position: "sticky",
  };

  const contentStyle = {
    overflowY: "auto",
    maxHeight: "calc(87vh - 120px)",
    padding: "10px",
    flexGrow: 1,
  };

  // Tab button component with emoji icon
  const TabButton = ({ index, icon, label, isActive, onClick, style = {} }) => (
    <button
      className={`btn button ${isActive ? " activebtn" : ""}`}
      onClick={() => onClick(index)}
      style={{
        margin: "0 5px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        ...style
      }}
    >
      <span style={{ fontSize: "16px" }}>{icon}</span>
      {label}
    </button>
  );

  return (
    <>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div className="scroll-container w-100">
            <div
              className="d-flex buttoncont"
              style={{
                marginBottom: "25px",
                overflow: "auto",
                whiteSpace: "nowrap",
                WebkitOverflowScrolling: "touch",
                msOverflowStyle: "none",
                scrollbarWidth: "thin",
                scrollbarHeight: "1px",
              }}
            >
              {currentUser && currentUser.userType === "TRAINEE" ? (
                <></>
              ) : (
                <>
                  <TabButton
                    index={0}
                    icon="📊"
                    label="Progress"
                    isActive={activebtnTab === 0}
                    onClick={handleTabClick}
                  />

                  {isTabVisible("Environment") && (
                    <TabButton
                      index={1}
                      icon="🌱"
                      label="Environment"
                      isActive={activebtnTab === 1}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Energy") && (
                    <TabButton
                      index={2}
                      icon="⚡"
                      label="Energy"
                      isActive={activebtnTab === 2}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Emission") && (
                    <TabButton
                      index={3}
                      icon="☁️"
                      label="Emission"
                      isActive={activebtnTab === 3}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Water") && (
                    <TabButton
                      index={4}
                      icon="💧"
                      label="Water"
                      isActive={activebtnTab === 4}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Waste") && (
                    <TabButton
                      index={5}
                      icon="🗑️"
                      label="Waste"
                      isActive={activebtnTab === 5}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Intensity") && (
                    <TabButton
                      index={12}
                      icon="📈"
                      label="Intensity"
                      isActive={activebtnTab === 12}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Diversity") && (
                    <TabButton
                      index={6}
                      icon="👥"
                      label="Diversity"
                      isActive={activebtnTab === 6}
                      onClick={handleTabClick}
                    />
                  )}

                  {isTabVisible("Employment") &&
                    companyFramework &&
                    companyFramework.includes(48) && (
                      <TabButton
                        index={7}
                        icon="💼"
                        label="Employment"
                        isActive={activebtnTab === 7}
                        onClick={handleTabClick}
                      />
                    )}

                  {isTabVisible("Employment") &&
                    companyFramework &&
                    companyFramework.includes(48) && (
                      <TabButton
                        index={15}
                        icon="💼"
                        label="Occupency"
                        isActive={activebtnTab === 15}
                        onClick={handleTabClick}
                      />
                    )}

                  {isTabVisible("Health & Safety") && (
                    <TabButton
                      index={8}
                      icon="🛡️"
                      label="Health & Safety"
                      isActive={activebtnTab === 8}
                      onClick={handleTabClick}
                    />
                  )}

                  {companyFramework && companyFramework.includes(1) && (
                    <TabButton
                      index={9}
                      icon="🎓"
                      label="Training"
                      isActive={activebtnTab === 9}
                      onClick={handleTabClick}
                    />
                  )}

                  {companyId && companyId !== "351" && <TabButton
                    index={10}
                    icon="👨‍🏫"
                    label="Trainer Overview"
                    isActive={activebtnTab === 10}
                    onClick={handleTabClick}
                  />}
                </>
              )}

              {companyId && companyId !== "351" && <TabButton
                index={11}
                icon="👨‍🎓"
                label="Trainee Overview"
                isActive={activebtnTab === 11}
                onClick={handleTabClick}
              />}
            </div>
          </div>
          <div style={contentStyle}>{renderUI()}</div>
        </div>
      </div>
    </>
  );
};

export default TabsComponent;